import React, { useState } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline, Fab, IconButton, Grid } from '@mui/material';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { lightTheme, darkTheme } from './theme'; // Import both themes
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';
import FacebookIcon from '@mui/icons-material/Facebook';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

import Home from './pages/home';
import About from './pages/about';
import Services from './pages/services';
import Contact from './pages/contact';

function App() {
  const [darkMode, setDarkMode] = useState(false);

  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
  };

  return (
    <ThemeProvider theme={darkMode ? darkTheme : lightTheme}>
      <CssBaseline />
      <Router>
        <Navbar darkMode={darkMode} />
        
        <Routes>
          <Route path="/" element={<Home darkMode={darkMode}/>} />
          <Route path="/about" element={<About darkMode={darkMode} />}  />
          <Route path="/services" element={<Services darkMode={darkMode} />} />
          <Route path="/contact" element={<Contact darkMode={darkMode} />} />
        </Routes>

        <Footer darkMode={darkMode} />

        {/* Floating Action Button for Dark Mode Toggle */}
        <Fab
          color="primary"
          onClick={toggleDarkMode}
          sx={{
            position: 'fixed',
            bottom: 16,
            right: 16,
            backgroundColor: darkMode ? '#333' : '#f57c00',
            color: '#fff',
            '&:hover': {
              backgroundColor: darkMode ? '#555' : '#ff9800',
            },
          }}
        >
          {darkMode ? <LightModeIcon /> : <DarkModeIcon />}
        </Fab>

        {/* Social Media Icons - Displayed Vertically */}
        <Grid 
          container 
          direction="column" // Stack icons vertically
          spacing={2} 
          sx={{ position: 'fixed', bottom: 140, left: 16 }}
        >
          <Grid item>
            <IconButton 
              color="inherit" 
              href="https://www.facebook.com/profile.php?id=61567810401210"
              sx={{
                width: 56,
                height: 56,
                borderRadius: '50%', 
                backgroundColor: darkMode ? '#3b5998' : '#e7f3ff',
                '&:hover': {
                  backgroundColor: darkMode ? '#4e69b3' : '#d0e1ff',
                },
              }}
            >
              <FacebookIcon sx={{ fontSize: 30, color: darkMode ? '#fff' : '#3b5998' }} />
            </IconButton>
          </Grid>
          <Grid item>
            <IconButton 
              color="inherit" 
              href="https://www.linkedin.com/in/fincal-business-solutions-67a656334/"
              sx={{
                width: 56,
                height: 56,
                borderRadius: '50%', 
                backgroundColor: darkMode ? '#0077b5' : '#e7f3ff',
                '&:hover': {
                  backgroundColor: darkMode ? '#005582' : '#d0e1ff',
                },
              }}
            >
              <LinkedInIcon sx={{ fontSize: 30, color: darkMode ? '#fff' : '#0077b5' }} />
            </IconButton>
          </Grid>
          <Grid item>
            <IconButton 
              color="inherit" 
              href="https://wa.me/+254719269649"
              sx={{
                width: 56,
                height: 56,
                borderRadius: '50%', 
                backgroundColor: darkMode ? '#25D366' : '#e7f3ff',
                '&:hover': {
                  backgroundColor: darkMode ? '#1aa34a' : '#d0e1ff',
                },
              }}
            >
              <WhatsAppIcon sx={{ fontSize: 30, color: darkMode ? '#fff' : '#25D366' }} />
            </IconButton>
          </Grid>
        </Grid>
      </Router>
    </ThemeProvider>
  );
}

export default App;
